import { useState } from "react";
import "./iconButton.scss";
import { Heading } from "../../Elements/Heading";
import { UntitledColorizeIcon } from "../../Basic/icons";
import type { IconButtonProps } from "./IconButton.interface.ts";

/**
 * Primary UI component for user interaction
 */
export function IconButton (props:IconButtonProps) {
  const [isActive, setIsActive] = useState(props.initiallyActive ?? false);

  const handleClick = () => {
    setIsActive(!isActive);
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <button
      id={props.buttonId}
      aria-label={props.buttonId}
      type="button"
      disabled={props.disabled}
      className={["storybook-icon-button", props.className].join(" ")}
      onClick={handleClick}
      style={props?.style}
    >
      {props.label && <Heading
          text={props.label}
          type={props.headlineSize ? props.headlineSize : "h3"}
        />}
      {props.icon && <UntitledColorizeIcon
          name={isActive ? "chevron-down" : "chevron-left"}
          alt={props.alt}
        />}
    </button>
  );
}
